import {
  ArcheryIcon,
  HuntingIcon,
  FishingIcon,
  BowsIcon,
  CrossbowsIcon,
  BowfishingIcon,
  BroadheadsIcon,
  TargetsIcon,
  HuntingApparelIcon,
  TreestandsIcon,
  HuntingBlindsIcon,
  OpticsIcon,
  GameCallsIcon,
  GameCamerasIcon,
  GameProcessingIcon,
  PacksIcon,
  SaddleHuntingIcon,
} from '../assets/icons';
import { STORE_SIDEBAR_CATEGORIES, STORE_SIDEBAR_SUBCATEGORIES } from './storeTaxonomy';

const CATEGORY_ICON_BY_OPTION = {
  archery: ArcheryIcon,
  hunting: HuntingIcon,
  fishing: FishingIcon,
};

const SUBCATEGORY_ICON_BY_OPTION = {
  'compound-bows': BowsIcon,
  crossbows: CrossbowsIcon,
  bowfishing: BowfishingIcon,
  broadheads: BroadheadsIcon,
  targets: TargetsIcon,
  'hunting-apparel': HuntingApparelIcon,
  treestands: TreestandsIcon,
  blinds: HuntingBlindsIcon,
  optics: OpticsIcon,
  'game-calls': GameCallsIcon,
  'game-cameras': GameCamerasIcon,
  'game-processing': GameProcessingIcon,
  'hunting-packs': PacksIcon,
  'saddle-hunting': SaddleHuntingIcon,
};

const CATEGORY_ORDER = ['archery', 'hunting', 'fishing'];
const SUBCATEGORY_ORDER = [
  'compound-bows',
  'crossbows',
  'bowfishing',
  'broadheads',
  'targets',
  'hunting-apparel',
  'treestands',
  'blinds',
  'optics',
  'game-calls',
  'game-cameras',
  'game-processing',
  'hunting-packs',
  'saddle-hunting',
];

const categoryByOption = STORE_SIDEBAR_CATEGORIES.reduce((acc, item) => {
  return item?.option ? { ...acc, [item.option]: item } : acc;
}, {});

const subcategoryByOption = STORE_SIDEBAR_SUBCATEGORIES.reduce((acc, item) => {
  return item?.option ? { ...acc, [item.option]: item } : acc;
}, {});

export const SEARCH_NAVIGATION_CATEGORY_ITEMS = CATEGORY_ORDER.map(option => {
  const category = categoryByOption[option];
  const img = CATEGORY_ICON_BY_OPTION[option];

  return category && img
    ? {
        label: category.label,
        category: category.option,
        img,
      }
    : null;
}).filter(Boolean);

export const SEARCH_NAVIGATION_SUBCATEGORY_ITEMS = SUBCATEGORY_ORDER.map(option => {
  const subcategory = subcategoryByOption[option];
  const img = SUBCATEGORY_ICON_BY_OPTION[option];

  return subcategory && img
    ? {
        label: subcategory.label,
        option: subcategory.option,
        parentCategory: subcategory.category,
        img,
      }
    : null;
}).filter(Boolean);
